const AddressItem = ({ address, onEdit, onDelete }) => (
	<div className={`relative border-2 rounded-xl p-5 transition-all duration-300 w-full ${address.isDefault
			? 'border-[#8d6e63] bg-[#efe0d0]/30 shadow-inner'
			: 'border-[#eaddcf] bg-white/40 hover:border-[#a1887f] hover:shadow-lg'
		}`}
		style={{ backgroundImage: address.isDefault ? "url('https://www.transparenttextures.com/patterns/wood-pattern.png')" : "none" }}
	>
		{/* Artisan Badge for Default Address */}
		{address.isDefault && (
			<div className="absolute -top-3 left-4">
				<span className="px-3 py-1 text-[10px] font-serif font-bold uppercase tracking-widest bg-[#5d4037] text-[#fdfaf6] rounded-sm shadow-sm border border-[#3e2723]">
					Primary Workshop
				</span>
			</div>
		)}

		<div className="space-y-1.5 mt-2">
			<h3 className="font-serif font-bold text-[#5d4037] text-lg flex items-center">
				<span className="w-1.5 h-6 bg-[#8d6e63] mr-3 rounded-full opacity-50"></span>
				{address.fullName}
			</h3>

			<div className="pl-4 border-l border-[#eaddcf] ml-0.5 space-y-1">
				<p className="text-[#8d6e63] font-medium text-sm italic">{address.phone}</p>
				<p className="text-[#6d4c41] font-serif">{address.addressLine1}</p>
				{address.addressLine2 && <p className="text-[#6d4c41] font-serif">{address.addressLine2}</p>}
				<p className="text-[#6d4c41] font-serif">
					{address.city}, {address.state} <span className="font-mono text-[#a1887f]">{address.zipCode}</span>
				</p>
				<p className="text-[#a1887f] text-xs font-bold uppercase tracking-tighter">{address.country}</p>
			</div>
		</div>

		<div className="mt-5 pt-3 flex space-x-4 border-t border-[#efe0d0]">
			<button
				onClick={() => { onEdit(address) }}
				className="flex items-center text-xs font-serif font-bold text-[#8d6e63] hover:text-[#5d4037] transition-colors group"
			>
				<span className="mr-1 group-hover:rotate-12 transition-transform">✎</span>
				Refine
			</button>
			<button
				onClick={() => onDelete(address)}
				className="flex items-center text-xs font-serif font-bold text-[#e57373] hover:text-[#d32f2f] transition-colors group"
			>
				<span className="mr-1 group-hover:scale-110 transition-transform">✕</span>
				Remove
			</button>
		</div>
	</div>
);

export default AddressItem;